export const AUTO_APPROVED = "AUTO_APPROVED";
export const FAILED = "FAILED";
export const VERIFIED = "VERIFIED";
export const NOT_ATTEMPED = "NOT_ATTEMPED";
export const FAILED_EXPIRED = "FAILED_EXPIRED";
